import React from 'react'
import ActionButton, { ActionButtonProps } from '.'
import './styles/cancelButton.scss'

export const CancelButton = (props: ActionButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <ActionButton className="cancel-button" {...props}>
        Cancel
    </ActionButton>
)
